export var InsightsCustomEventName;
(function (InsightsCustomEventName) {
    InsightsCustomEventName["vpcInteraction"] = "vpc_interaction";
    InsightsCustomEventName["navigation"] = "navigation";
    InsightsCustomEventName["bookRemotePlanning"] = "book_remote_planning";
    InsightsCustomEventName["landingPageSelectStart"] = "landing_page_select_start";
    InsightsCustomEventName["toggleModal"] = "toggle_modal";
    InsightsCustomEventName["toggleHamburgerMenu"] = "toggle_hamburger_menu";
    InsightsCustomEventName["currentLocation"] = "current_location";
    InsightsCustomEventName["loginToAccount"] = "login_to_account";
    InsightsCustomEventName["logoutFromAccount"] = "logout_to_account";
    InsightsCustomEventName["saveDesignClick"] = "click_save_design";
    InsightsCustomEventName["shareDesignStateChange"] = "click_share_design_card_state";
    InsightsCustomEventName["shareViaEmail"] = "share_via_email";
    InsightsCustomEventName["shareViaSms"] = "share_via_sms";
    InsightsCustomEventName["onSummaryClicked"] = "on_summary_clicked";
    InsightsCustomEventName["goToSummary"] = "go_to_summary";
    InsightsCustomEventName["summaryLoaded"] = "summary_loaded";
    InsightsCustomEventName["selectTab"] = "select_tab";
    InsightsCustomEventName["selectImage"] = "select_image";
    InsightsCustomEventName["setPostcode"] = "set_postcode";
    InsightsCustomEventName["setStoreLocation"] = "set_store_location";
    InsightsCustomEventName["shareViaClipboard"] = "share_via_clipboard";
    InsightsCustomEventName["copyDesignCode"] = "copy_design_code";
    InsightsCustomEventName["renderPrintQrCode"] = "render_print_qr_code";
    InsightsCustomEventName["financialServicesMoreInfoClick"] = "financial_services_more_info_click";
    InsightsCustomEventName["financialServicesContinueButtonClick"] = "financial_services_continue_button_click";
})(InsightsCustomEventName || (InsightsCustomEventName = {}));
//# sourceMappingURL=InsightsCustomEventName.js.map